import { atom } from "jotai";
import { fetchSelectedAccountUserTreeAtom, selectedAccountUserIdAtom } from "./accounts";
import { deviceModelsAtom } from "./basic";
import { fetchCurrentIrrigationPlanStatesAtom } from "./irrigation-plan-domain";
import {
  fetchCurrentLICPacketsAtom,
  fetchLatestLICEventsAtom,
  fetchLatestMeshDeviceEventsAtom,
  fetchLicStatesAtom,
} from "./lic-domain";
import { fetchCurrentProjectStatesAtom } from "./project-states";
import { selectedPropertyIdAtom, virtualDeviceConfigurationAtom } from "./property-domain";

export const refetchDataAtom = atom(null, async (get, set) => {
  const selectedAccountUserId = get(selectedAccountUserIdAtom);
  // console.log("🔄 Refetching data", selectedAccountUserId);
  if (!selectedAccountUserId) {
    return { success: true } as const;
  }

  await set(fetchSelectedAccountUserTreeAtom);

  const selectedPropertyId = get(selectedPropertyIdAtom);
  if (!selectedPropertyId) {
    return { success: true } as const;
  }

  try {
    await Promise.all([
      set(fetchCurrentProjectStatesAtom),
      set(fetchCurrentIrrigationPlanStatesAtom),
      set(fetchCurrentLICPacketsAtom),
      set(fetchLicStatesAtom),
      set(virtualDeviceConfigurationAtom),
      set(deviceModelsAtom),
      set(fetchLatestLICEventsAtom),
      set(fetchLatestMeshDeviceEventsAtom),
    ]);
  } catch (error) {
    // Errors handled by withOperationHandlingAtom inside each fetcher
  }

  return { success: true } as const;
});
refetchDataAtom.debugLabel = "refetchDataAtom";
